// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCVquw6_N_hnTcukM3UMFqprholHoYeUfQ",
    authDomain: "axipapptest.firebaseapp.com",
    databaseURL: "https://axipapptest.firebaseio.com",
    projectId: "axipapptest",
    storageBucket: "axipapptest.appspot.com",
    messagingSenderId: "306447099330",
  },
  stripe_publishable: "pk_test_vMBxbKGefK41zpgm77ILhIDA",
  gtm_id: "GTM-TG9LWHL"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
